import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Bolt from '@nationwide-bolt/bundle-core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { extendPrototypes } from './prototype-extensions';

declare global {
    interface Window {
        WebComponents: {
            ready: boolean;
        };
    }
}

if (environment.PRODUCTION) {
    enableProdMode();
}

Bolt.initialize().then(() => {
    extendPrototypes();
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((error) => console.log(error));
});
